import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhStatusComponent } from './components/fh-status.component';
import { TranslateModule } from '@ngx-translate/core';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';
import { FhCardModule } from '@fh-client-interaction-frontends/fh-card';

@NgModule({
  imports: [CommonModule, TranslateModule, FhTextModule, FhCardModule],
  exports: [FhStatusComponent],
  declarations: [FhStatusComponent]
})
export class FhStatusModule {}
